const columnConfig = [
  {
    key: 'date',
    label: 'Tanggal',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      minWidth: '120px',
      textAlign: 'left',
      fontWeight: 400,
    },
    tdStyle: {
      textTransform: 'capitalize',
      minWidth: '120px',
      textAlign: 'left',
    },
    tdClass: 'text-[#333333]',
  },
  {
    key: 'target_account',
    label: 'Target Akun',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      minWidth: '180px',
      textAlign: 'left',
      fontWeight: 400,
    },
    tdStyle: {
      textTransform: 'capitalize',
      minWidth: '180px',
      textAlign: 'left',
    },
    tdClass: 'text-[#333333]',
  },
  {
    key: 'nominal',
    label: 'Nominal',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      minWidth: '120px',
      textAlign: 'left',
      fontWeight: 400,
    },
    tdStyle: {
      textTransform: 'capitalize',
      minWidth: '120px',
      textAlign: 'left',
    },
    tdClass: 'text-[#333333]',
  },
  {
    key: 'platform_name',
    label: 'Platform',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      minWidth: '50px',
      textAlign: 'left',
      fontWeight: 400,
    },
    tdStyle: {
      minWidth: '50px',
      textAlign: 'center',
    },
    tdClass: 'place-items-center',
  },
  {
    key: 'status',
    label: 'Status',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      minWidth: '120px',
      textAlign: 'left',
      fontWeight: 400,
    },
    tdStyle: {
      textTransform: 'capitalize',
      minWidth: '120px',
      textAlign: 'left',
    },
  },
  {
    key: 'action',
    label: '',
    tdStyle: {
      minWidth: '120px',
      textAlign: 'left',
    },
  },
]

export default columnConfig
